<template>
<div>
  <div v-if="widthMax > 768" class="columns mg-b-20" id="activityNav">
    <div class="column">
      <router-link
        to="/board-view-dashboard"
        class="button is-large btnNavNotActive"
        :class="{ btnNavActive: nav.dashboard && getRule == 'exclusiveboard', btnNavActiveBoard: nav.dashboard && getRule == 'board'}"
      >
        <span class="icon is-medium">
          <i class="fas fa-chart-line navColorNotActive" :class="{ navColorActive: nav.dashboard}"></i>
        </span>
        <span class="navColorNotActive" :class="{ navColorActive: nav.dashboard}">Dashboard</span>
      </router-link>
    </div>
    <div class="column">
      <router-link
        to="/report-company-list"
        class="button is-large btnNavNotActive"
        :class="{ btnNavActive: nav.smartReport && getRule == 'exclusiveboard', btnNavActiveBoard: nav.smartReport && getRule == 'board' }"
      >
        <span class="icon is-medium">
          <i class="fas fa-list-ul navColorNotActive" :class="{ navColorActive: nav.smartReport}"></i>
        </span>
        <span class="navColorNotActive" :class="{ navColorActive: nav.smartReport}">Smart report</span>
      </router-link>
    </div>
  </div>
  <div v-else class="is-flex is-align-center is-justify-center mg-b-20" id="navMobileActivity">
    <div @click="activeNav('/board-view-dashboard')" class="flex-1 nav-mobile-activity" :style="{borderColor:(nav.dashboard)?'#fff':'#00a79d'}">
      <p class="has-text-centered has-text-white has-text-weight-normal is-size-6">Dashboard</p>
    </div>
    <div @click="activeNav('/report-company-list')" class="flex-1 nav-mobile-activity" :style="{borderColor:(nav.smartReport)?'#fff':'#00a79d'}">
      <p class="has-text-centered has-text-white has-text-weight-normal is-size-6">Smart report</p>
    </div>
  </div>
</div>
</template>
/* eslint-disable */
<style scoped>
.navColorActive {
  color: #fff !important;
}
.btnNavActive {
  background-color: #E65525 !important;
  width: 100%;
}
.btnNavActiveBoard {
  background-color: #016299 !important;
  width: 100%;
}
.navColorNotActive {
  color: #d8d8d8;
}
.btnNavNotActive {
  background-color: #fff;
  width: 100%;
}
#activityNav{
  min-height: 78px;
  display: -webkit-box!important;
}
@media only screen and (max-width: 768px) {
  #activityNav{
    min-height: 78px;
    display: unset !important;
  }
}
.nav-mobile-activity{
  border-bottom-width: 3px;
  border-bottom-style: solid;
  margin-left: 10px;
  margin-right: 10px;
  cursor: pointer;
}
#navMobileActivity{
  background-color: #00a79d!important;
}
</style>

<script>
// @ is an alias to /src

export default {
  props: {
    nav: Object,
  },
  computed: {
    getRule() {
      return this.$store.getters.getRule;
    }
  },
  data() {
    return {
      widthMax: window.innerWidth,
    };
  },
  methods: {
    activeNav(link) {
      this.$router.push(link);
    },

  },
};
</script>
